export default __webpack_public_path__ + "static/media/search_expert.dc64084e.svg";